import { useQuery } from "react-query";

import { getEpd } from "~/components/Forms/DealerPassportForm2/requests/getEpd";

export default function useGetEpd(dealerId: string) {
  return useQuery({
    queryKey: ["dealerEpd", { dealerId }],
    queryFn: () => getEpd(dealerId),
    refetchOnWindowFocus: false,
    enabled: Boolean(dealerId),
  });
}
